import {
  ExtractDeliveryNoteDocumentMessageInput,
  extractDeliveryNoteDocumentMessageInputSchema,
} from '@prompt-bridge/shared/validations';

export const isDeliveryNoteInput = (
  input: unknown
): input is ExtractDeliveryNoteDocumentMessageInput => {
  const result = extractDeliveryNoteDocumentMessageInputSchema.safeParse(input);
  return result.success;
};
